import { load } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  const disciplineFilter = document.querySelector('#DisciplineTagFilter');
  if (disciplineFilter) {
    if (!disciplineFilter.length) {
      return;
    }

    disciplineFilter.addEventListener('change', function() {
      window.location.href = disciplineFilter.value;
    });
  }

  const locationFilter = document.querySelector('#LocationTagFilter');
  if (locationFilter) {
    if (!locationFilter.length) {
      return;
    }

    locationFilter.addEventListener('change', function() {
      window.location.href = locationFilter.value;
    });
  }

  const ambassadorListingSlider = document.querySelector(
    '.ambassadors__slider'
  );

  if (ambassadorListingSlider) {
    this.ambassadorListingSlider = new Flickity(ambassadorListingSlider, {
      freeScroll: false,
      autoplay: false,
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'center',
      watchCSS: true,
      wrapAround: true,
    });
  }
});
